import * as React from 'react';
import { useHandleResolveAuthError } from './utils/useHandleResolveAuthError';
import { useDeactivatedLabelTitle } from '../utils';
import { OfferFromHistory } from '../../components/Desktop';
import { useOffersHistoryContext } from '../../context';

export const OfferFromHistoryContainer: React.VFC = () => {
  const {
    data: {
      offers: { data, isError, isFetching, isAuthError },
    },
    activeOfferId,
    onOfferLinkClick,
  } = useOffersHistoryContext();

  /** Данные для выбранного оффера загружаются асинхронно, поэтому в модалке сначала будет прелоадер */
  const offerFromHistory = React.useMemo(() => (activeOfferId ? data[activeOfferId] : null), [data, activeOfferId]);

  const deactivatedTitle = useDeactivatedLabelTitle(offerFromHistory);

  const handleResolveAuthError = useHandleResolveAuthError();

  return (
    <OfferFromHistory
      offer={offerFromHistory}
      onOfferLinkClick={onOfferLinkClick}
      isLoading={isFetching}
      isError={isError}
      isAuthError={isAuthError}
      deactivatedTitle={deactivatedTitle}
      onAuthErrorClick={handleResolveAuthError}
    />
  );
};
